<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      <v-row align="center" justify="center" class="mt-15">
        <v-col cols="12" sm="8" md="6" lg="5" xl="6">
          <div class="mw-400">
            <v-skeleton-loader type="list-item-avatar, list-item-three-line, list-item-three-line, list-item-three-line, list-item-three-line" class="mb-3"></v-skeleton-loader>
          </div>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="2" class="text-center">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Configurações Gerais
      </div>
      <v-row align="center" justify="start" class="mt-15">
        <v-col cols="12" sm="8" md="6" lg="5" xl="6">
          <div class="text-h3 text-primary w-100 mb-3">
            Campos para salvar endpoint de webhook cliente e usina
          </div>
          <div class="mw-400">
            <v-text-field
              v-model="dados.win_url"
              class="mb-5"
              hide-details
              outlined
              label="URL"
            ></v-text-field>
            <v-text-field
              v-model="dados.win_token"
              class="mb-4"
              hide-details
              outlined
              label="Token"
            ></v-text-field>
            <div class="text-right">
              <v-btn color="primary"
                class="mb-4"
                @click="edit ? atualizaIntegracao() : novaIntegracao()"
                :loading="salvando"
                :disabled="salvando"
              >
                {{edit ? 'Atualizar' : 'Salvar'}}
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-15" v-if="userInfo && userInfo.fk_dis_id_distribuidor && userInfo.grupo.gru_nome === 'Administrador'">
        <v-col cols="12">
          <div class="text-h3 text-primary w-100 mb-0">
            Acesso dos integradores
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-h3 text-primary w-100 mb-3">
            Usinas
          </div>
        </v-col>
        <v-col cols="12" sm="8" md="6">
          <v-autocomplete
            :menu-props="{ offsetY: true}"
            v-model="checkedModuloDetalhes"
            :items="moduloDetalhes"
            clearable
            multiple
            clear-icon="close"
            label="Módulos de acesso*"
            append-icon="expand_more"
            outlined
          >
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item v-on="on" v-bind="attrs">
                <v-list-item-icon>
                  <v-icon>
                    {{ checkedModuloDetalhes.includes(item.value) ? 'check_box' : 'check_box_outline_blank' }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text" class="text-left"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row v-if="userInfo && userInfo.fk_dis_id_distribuidor && userInfo.grupo.gru_nome === 'Administrador'">
        <v-col cols="12" sm="8" md="6">
          <div class="text-right">
            <v-btn color="primary"
              class="mb-4"
              @click="atualizaModuloDetalhes()"
              :loading="loadingModulos"
              :disabled="loadingModulos"
            >
              Salvar
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Api from '../../../config/api.helper'

// import Api from '@API'
export default {
  data () {
    return {
      userInfo: null,
      loading: false,
      loadingModulos: false,
      dados: {
        uuid_win_id: '',
        win_url: '',
        win_token: ''
      },
      grupoIntegradorUuid: '',
      modulos: [],
      moduloDetalhes: [],
      checkedModuloDetalhes: [],
      edit: false,
      salvando: false
    }
  },
  methods: {
    loadFunctions () {
      this.getUser()
      this.listaIntegracao()
      this.getGrupo()
      this.getGrupoModulos()
      this.getModulos()
    },
    getGrupo () {
      Api.get('grupos')
        .then(res => {
          if (res.data.length) {
            this.grupoIntegradorUuid = res.data.find(grupo => grupo.gru_nome === 'Integrador').uuid_gru_id
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao consultar lista de grupos!',
            color: 'error'
          })
        })
    },
    getGrupoModulos () {
      Api.get('grupos-modulos')
        .then(res => {
          if (res.data.length) {
            this.filterUsinasModuloDetalhesChecked(res.data)
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao consultar lista de grupos!',
            color: 'error'
          })
        })
    },
    getModulos () {
      Api.get('modulos')
        .then(res => {
          this.modulos = res.data
          this.filterUsinasModuloDetalhes(this.modulos)
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao consultar lista de permissões!',
            color: 'error'
          })
        })
    },
    atualizaModuloDetalhes () {
      this.loadingModulos = true
      Api.post('grupos/edita-modulo-detalhes', {
        gru_modulos: this.checkedModuloDetalhes,
        uuid_gru_id: this.grupoIntegradorUuid
      })
        .then(res => {
          this.loadingModulos = false
          this.$root.SnackControl.open(this, {
            text: 'Modulos atualizados',
            color: 'success'
          })
        })
        .catch(err => {
          this.loadingModulos = false
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao atualizar lista de permissões!',
            color: 'error'
          })
        })
    },
    novaIntegracao () {
      this.salvando = true
      Api.post('configuracoes-gerais', this.dados)
        .then(res => {
          this.listaIntegracao()
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: res.data.message,
            color: 'success'
          })
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao gravar os dados!',
            color: 'error'
          })
        })
    },
    atualizaIntegracao () {
      this.salvando = true
      Api.put('configuracoes-gerais', this.dados)
        .then(res => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: res.data.message,
            color: 'success'
          })
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao atualizar os dados!',
            color: 'error'
          })
        })
    },
    async listaIntegracao () {
      await Api.get('configuracoes-gerais')
        .then(res => {
          if (res.data.data) {
            this.dados = res.data.data
            this.edit = true
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
        })
    },
    filterUsinasModuloDetalhesChecked (gruposModulos) {
      this.checkedModuloDetalhes = gruposModulos.filter(grupoModulo => grupoModulo.grupo && grupoModulo.grupo.gru_nome && grupoModulo.grupo.gru_nome === 'Integrador')
        .filter(grupoModulo => grupoModulo.modulo && grupoModulo.modulo.mod_nome === 'Usinas')
        .filter(grupoModulo => grupoModulo.modulo_detalhes)
        .map(grupoModulo => grupoModulo.modulo_detalhes.uuid_mod_det_id)
    },
    filterUsinasModuloDetalhes (modulos) {
      this.moduloDetalhes = modulos.find(modulo => modulo.mod_nome === 'Usinas').modulo_detalhes.map(modulo => ({text: modulo.mod_det_nome, value: modulo.uuid_mod_det_id}))
    },
    getUser () {
      const userInfo = localStorage.getItem('user')
      this.userInfo = JSON.parse(userInfo)
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.mw-400 {
  max-width: 400px;
}
.ui-btn-inherit {
  margin-bottom: 3px!important;
  min-height: 10px!important;
}
.mw_img {
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/ConfiguracoesGerais.vue